import React from 'react'
import Table from 'antd/lib/table'
import Button from 'antd/lib/button'
import Row from 'antd/lib/row'
import Col from 'antd/lib/col'

import { Spinner } from '~/components'

import { fetchAndSaveETHYieldData, fetchETHYieldData } from '~/firebase'
import { PromiseStates } from '~/types'


export default class AdminPanel extends React.Component {
  state = {
    didPromiseResolve: 'IDLE' as PromiseStates,
    fiatValue: {},
    userRecords: {}, // Associative object of users that have orders
    yieldData: {},
  }

  onFetchETHYieldData = () => fetchETHYieldData().then(data => this.setState(data))
  onFetchAndSaveETHYieldData = () => fetchAndSaveETHYieldData()
    .then(({promise, ...data}) => (this.setState({...data, didPromiseResolve: 'LOADING'}), promise))
    .then(() => this.setState({didPromiseResolve: 'FINISHED'}))
    .catch(e => {
      console.error(e.message)
      this.setState({didPromiseResolve: 'ERROR'})
    })

  displaySpinner = () => ({
    ERROR: () => <span title="error: see details in console" style={{pointerEvents: 'initial'}}> ✗</span>,
    FINISHED: () => <span> ✓</span>,
    IDLE: () => null,
    LOADING: () => <Spinner inline/>,
  }[this.state.didPromiseResolve]())


  render() {
    return (
      <main className="isoLayoutContentWrapper sc-fjdhpX cKswoM adminPanel" style={{height: '100%'}}>

        <section className="sc-iRbamj gXBuxZ">
          <h2 className="isoComponentTitle sc-jzJRlG kviPuT">Ethereum data </h2>
          <Row type="flex" justify="space-around" align="middle">
            <Col span={7}><Button onClick={this.onFetchETHYieldData}>Fetch current ETH Yield data</Button></Col>
            <Col span={2}><p>source:</p></Col>
            <Col span={12}>
              <p>
                <a href="https://www.etherchain.org/api/miningEstimator">etherchain.org/api/miningEstimator</a><br/>
                <a href="https://min-api.cryptocompare.com/data/price?fsym=ETH&tsyms=USD,EUR,CZK">cryptocompare/data/price</a>
              </p>
            </Col>
          </Row>
          <Row type="flex" justify="space-around" align="middle">
            <Col span={21}>
              <pre>
                {JSON.stringify(this.state, (k, v) => ['didPromiseResolve', 'orders'].some(f => f === k) ? undefined : v, ' ')}
              </pre>
            </Col>
          </Row>

          <br/>
          <Row type="flex" justify="space-around" align="middle">
            <Col span={9}>
              <Button onClick={this.onFetchAndSaveETHYieldData} ghost type="danger" className="ant-btn-dashed"
              >Fetch & Save current ETH Yield data to Firebase<this.displaySpinner/></Button>
            </Col>
            <Col span={12}>
              <p><a
                href="https://console.firebase.google.com/u/0/project/future-cloud-mining/database/future-cloud-mining/data/graphs/yield/eth"
              >See data in Firebase
              </a></p>
            </Col>
          </Row>
        </section>

      </main>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/API/index.tsx